import { useMemo, useState } from "react";
import Select from "react-select";
import type { Branch } from "../../dto/commons";
import { useBranches } from "../../hooks/use-commons";

interface Props {
  id?: string;
  value?: Branch[];
  onChange?: (newValue: Branch[]) => void;
}

export function BranchSelector({
  id = "branchSelector",
  value,
  onChange,
}: Props) {
  const [_selected, _setSelected] = useState<Branch[]>(value || []);

  const selected = value ?? _selected;
  const { data, isLoading } = useBranches();

  const branchOptions = useMemo(
    () => data?.map((d) => ({ label: d.name, value: d.id })) || [],
    [data],
  );

  const handleChange = (selected: Branch[]) => {
    if (value === undefined) {
      _setSelected(selected);
    }
    onChange?.(selected);
  };

  return (
    <Select
      id={id}
      options={branchOptions}
      isMulti
      isLoading={isLoading}
      placeholder="All Branches"
      value={branchOptions.filter((option) =>
        selected.some((b) => b.id === option.value),
      )}
      classNames={{
        control: () => "!border-gray-200",
      }}
      onChange={(selectedOptions) => {
        handleChange(
          selectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        );
      }}
      className="mt-1"
    />
  );
}
